// extracted by mini-css-extract-plugin
export default {"card_heading":"upcoming-exams_card_heading__3q2UK","topBar":"upcoming-exams_topBar__mq3mn","tableWrapper":"upcoming-exams_tableWrapper__F5TlF"};